<mat-form-field>
  <input *ngIf="!isLongText" [formControl]="email" [pattern]="this.regex" type="email" matInput="" placeholder="{{'Email address'|translate}}" required="" (change)="change()" />

  <mat-error i18n="@@Checkemailinformed">{{'Check email informed'|translate}}</mat-error>
</mat-form-field>
